import React from 'react'
import config from '../../config.json'
import Translation from '../Translation/cont/Translation'

class DashboardContactDialog extends React.Component {
    render() {
        const { onClose } = this.props
        const { consultation, accounting, support, contact } = config.dashboardcontent

        return (
            <div className="dialog-overlay" onClick={onClose}>
                <div className="dialog" onClick={e => e.stopPropagation()}>
                    <div className="dialog-header">
                        <span className="dialog-title text-small-regular"><Translation id="dashboard_contactheadline" /></span>
                        <button className="dialog-close" type="button" onClick={onClose}>✕</button>
                    </div>
                    <div className="dialog-body db-contact-dialog-body">
                        <div className="db-contact-section">
                            <p className="title-large-color"><Translation id="dashboard_consultation_accounting_headline" /></p>
                            <p className="text-regular-uppercase"><Translation id="dashboard_consultation_headline" /></p>
                            <p className="text-regular"><Translation id="dashboard_consultation_salutation" /> {consultation.name}</p>
                            <p className="text-regular-color db-contact-line--end">{consultation.mail}</p>
                            <p className="text-regular-uppercase"><Translation id="dashboard_accounting_headline" /></p>
                            <p className="text-regular-color">{accounting.mail}</p>
                        </div>
                        <div className="db-contact-section">
                            <p className="title-large-color"><Translation id="dashboard_contact_headline" /></p>
                            <p className="text-regular-uppercase"><Translation id="dashboard_contact_by_phone" /></p>
                            <p className="text-regular db-contact-line--end">{contact.number}</p>
                            <p className="text-regular-uppercase"><Translation id="dashboard_contact_postal" /></p>
                            <p className="text-regular">{contact.company}</p>
                            <p className="text-regular">{contact.address}</p>
                            <p className="text-regular">{contact.place}</p>
                            <p className="text-regular"><Translation id="dashboard_contact_postal_country" /></p>
                        </div>
                        <div className="db-contact-section">
                            <p className="title-large-color"><Translation id="dashboard_support_headline" /></p>
                            <p className="text-regular-uppercase"><Translation id="dashboard_errorsupport_headline" /></p>
                            <p className="text-regular-color db-contact-line--end">{support.errorsupport.mail}</p>
                            <p className="text-regular-uppercase"><Translation id="dashboard_admin_headline" /></p>
                            <p className="text-regular">{support.technology.name}</p>
                            <p className="text-regular-color">{support.technology.mail}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DashboardContactDialog
